import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import { useConfig } from '../../context/ConfigContext';

const Footer = () => {
    const { config } = useConfig();

    return (
        <footer className="bg-gray-900 text-gray-300 py-12">
            <div className="max-w-6xl mx-auto px-4">
                <div className="flex flex-col md:flex-row items-center justify-between gap-6">

                    {/* Brand */}
                    <div className="text-center md:text-left">
                        <h3 className="text-2xl font-bold text-white mb-2">
                            Islam 101
                        </h3>
                        <p className="text-sm text-gray-400 max-w-md">
                            A comprehensive platform to learn Quran, Hadith, Duas, and Islamic knowledge.
                        </p>
                    </div>

                    {/* Social Media */}
                    <div className="flex space-x-5">
                        {[
                            { icon: FaFacebookF, link: config?.socialLinks?.facebook },
                            { icon: FaTwitter, link: config?.socialLinks?.twitter },
                            { icon: FaInstagram, link: config?.socialLinks?.instagram },
                            { icon: FaYoutube, link: config?.socialLinks?.youtube },
                        ]
                            .filter(item => item.link && item.link.trim() !== '')
                            .map(({ icon: Icon, link }, index) => (
                                <a
                                    key={index}
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-emerald-600 transition-colors"
                                >
                                    <Icon className="text-white" />
                                </a>
                            ))}
                    </div>
                </div>

                {/* Bottom */}
                <div className="border-t border-gray-800 mt-8 pt-6 text-center text-sm text-gray-500">
                    © {new Date().getFullYear()} Islam 101. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;